<template>
  <div style="touch-action: none; touch-action: pan-y">
    <el-form :model="form" :rules="rules" ref="ruleForm">
      <h1>注册账号</h1>
      <!-- <p class="withMe">和我们一起进入数字时代</p> -->
      <el-row class="Row">
        <el-col :span="1" class="col-1">
          <i class="el-icon-user-solid iconStyle"></i>
        </el-col>
        <el-col :span="16">
          <el-row class="Row-1">注册账号</el-row>
          <el-form-item class="Row-2" prop="name">
            <input
              class="row-input"
              v-model="form.name"
              maxlength="11"
              placeholder="手机号"
              ref="username"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="Row">
        <el-col :span="1" class="col-1">
          <i class="el-icon-s-claim iconStyle"></i>
        </el-col>
        <el-col :span="14">
          <el-row class="Row-1">验证码</el-row>
          <el-form-item class="Row-2" prop="verification">
            <input class="row-input" v-model="form.verification" placeholder="验证码" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-row class="Row-3">
            <span class="get" @click="getVerifi" v-show="showGet">获取验证码</span>
            <span v-show="!showGet">{{ showTime }}s后重试</span>
          </el-row>
        </el-col>
      </el-row>
      <el-row class="Row">
        <el-col :span="1" class="col-1">
          <i class="el-icon-user-solid iconStyle"></i>
        </el-col>
        <el-col :span="16">
          <el-row class="Row-1">邀请码</el-row>
          <el-form-item class="Row-2" prop="invite">
            <input
              class="row-input"
              v-model="form.invite"
              disabled
              placeholder="邀请码"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="Row">
        <el-col :span="1" class="col-1">
          <i class="el-icon-lock iconStyle"></i>
        </el-col>
        <el-col :span="16" style="position: relative">
          <el-row class="Row-1">输入密码</el-row>
          <el-form-item class="Row-2" prop="password">
            <input
              class="row-input"
              v-model="form.password"
              type="password"
              placeholder="8~16位数字加字母"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="Row">
        <el-col :span="1" class="col-1">
          <i class="el-icon-lock iconStyle"></i>
        </el-col>
        <el-col :span="16">
          <el-row class="Row-1">确认密码</el-row>
          <el-form-item class="Row-2" prop="passwordAgain">
            <input
              class="row-input"
              v-model="form.passwordAgain"
              type="password"
              placeholder="8~16位数字加字母"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="agree">
        <span class="bigRound" @click="clickAgree">
          <span class="innerRound" v-show="agree"></span>
        </span>
        <span @click="clickAgree">我同意</span>
        《<span class="agreeClause" @click="agreement">服务条款</span>》
        <span class="toLogin">已有账号? <span @click="toLogin">下载APP</span></span>
      </el-row>
      <el-row class="next">
        <el-button
          class="nextBtn"
          type="primary"
          :disabled="!agree"
          @click="submitForm('ruleForm')"
          >下一步</el-button
        >
      </el-row>
      <!-- <el-row class="QR">
        <img src="../assets/1.png" class="QRcode" alt="" />
      </el-row> -->
    </el-form>

    <div class="slideVerifyMon" v-show="slideVerify">
      <div class="slideVerify">
        <PuzzleVerification
          v-model="slideVerify"
          :puzzleImgList="puzzleImgList"
          deviation="20"
          blockType="puzzle"
          :onSuccess="onSuccess"
        />
        <!-- <slide-verify
        ref="slideblock"
          :l="42"
          :r="10"  
          :w="widthMone"
          :h="155"
          @click.stop
          @success="onSuccess"
          @fail="onFail"
          @refresh="onRefresh"
          :slider-text="text"
        ></slide-verify> -->
        <!-- :imgs="puzzleImgList" -->
      </div>
    </div>
  </div>
</template>

<script>
import PuzzleVerification from "vue-puzzle-verification";
import cofig from "../store/config";
import {
  getRulesEncryptStr,
  getParamsEncryptStr,
  getDecryptStr,
  getIdDecryptStr,
  getPhoneStr,
} from "../utils/registrationLogic/encryption";
import newAppKey from "../utils/registrationLogic/appkey";
export default {
  components: { PuzzleVerification },
  data: function () {
    let invitationCode = this.$route.query.code;
    // 验证规则方法
    // 密码验证
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 8 || value.length > 16) {
        callback(new Error("密码长度为8~16位"));
      } else {
        if (this.form.passwordAgain !== "") {
          this.$refs.ruleForm.validateField("passwordAgain");
        }
        callback();
      }
    };
    // 再次输入密码
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      slideVerify: false,
      text: "向右滑",
      showTime: 120, // 倒计时
      showGet: true, // 获取验证码按钮
      agree: true, // 默认同意服务条款
      widthMone: "",
      // form表单项
      form: {
        name: "", // 账号
        verification: "", // 验证码
        invite: invitationCode, // 邀请码
        password: "", // 密码
        passwordAgain: "", // 重新输入密码
      },
      appkeySecret: {
        appkey: "",
        app_secret: "",
        public_key: "",
        private_key: "",
      },
      Jump: "",
      closeimg: true,
      correct: true,
      antiShake: true,
      puzzleImgList: [
        require("../assets/puzzleImg/puzz_1.png"),
        require("../assets/puzzleImg/puzz_2.png"),
        require("../assets/puzzleImg/puzz_3.png"),
        require("../assets/puzzleImg/puzz_4.png"),
        require("../assets/puzzleImg/puzz_5.png"),
        require("../assets/puzzleImg/puzz_6.png"),
        require("../assets/puzzleImg/puzz_7.png"),
        require("../assets/puzzleImg/puzz_8.png"),
        require("../assets/puzzleImg/puzz_9.png"),
      ],
      // 验证规则
      rules: {
        name: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            pattern: /^((1[3,4,5,6,7,8,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[1,7]))\d{8}$/,
            message: "请输入正确的手机号码",
          },
        ],
        verification: [
          {
            required: true,
            message: "请填写验证码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 6,
            message: "验证码为6位",
            trigger: "blur",
          },
        ],
        invite: [
          {
            required: true,
            message: "请填写邀请码",
            trigger: "blur",
          },
        ],
        password: [
          {
            validator: validatePass,
            trigger: "blur",
          },
          {
            pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/,
            message: "密码只能为字母加数字",
          },
        ],
        passwordAgain: [
          {
            validator: validatePass2,
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    let width = parseInt((document.documentElement.clientWidth * 0.7).toFixed(0));
    this.widthMone = width ? width : "280";
    // let appkey = this.$route.query.appKey
    // console.log(this.$route.query);
    if (this.$route.query.appKey == newAppKey.telephoneCharges.appkey) {
      this.appkeySecret = newAppKey.telephoneCharges;
      this.Jump = "downloadPage";
    } else if (this.$route.query.appKey == newAppKey.fullName.appkey) {
      this.appkeySecret = newAppKey.fullName;
      this.Jump = "fullNameData";
    } else if (this.$route.query.appKey == newAppKey.raisingChickens.appkey) {
      this.appkeySecret = newAppKey.raisingChickens;
      this.Jump = "sanAnYounong";
    } else if (this.$route.query.appKey == newAppKey.shareholder.appkey) {
      this.appkeySecret = newAppKey.shareholder;
      this.Jump = "shareholderMall";
    } else if (this.$route.query.appKey == newAppKey.fuyuan.appkey) {
      this.appkeySecret = newAppKey.fuyuan;
      this.Jump = "fuYuanProject";
    } else if (this.$route.query.appKey == newAppKey.winery.appkey) {
      this.appkeySecret = newAppKey.winery;
      this.Jump = "wineryDownload";
    } else if (this.$route.query.appKey == newAppKey.wineryAgrent.appkey) {
      this.appkeySecret = newAppKey.wineryAgrent;
      this.Jump = "wineryDownload";
    }
    // console.log(this.appkeySecret);
  },
  methods: {
    // 点击验证码发送倒计时
    validateBtn() {
      //倒计时
      this.showGet = !this.showGet;
      let time = 120;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.showGet = !this.showGet;
          this.showTime = 120;
        } else {
          time--;
          this.showTime--;
        }
      }, 1000);
    },
    onSuccess() {
      console.log("成功");
      this.$refs.ruleForm.validateField("name");
      if (
        !/^((1[3,4,5,6,7,8,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[1,7]))\d{8}$/.test(
          this.form.name
        )
      ) {
        this.$message({
          message: "请输入正确的手机号",
          type: "warning",
        });
        this.slideVerify = false;
      } else {
        // 实现发送验证码功能
        // this.showGet = !this.showGet
        console.log(this.form.name);
        this.validateBtn();
        let newPhone = { phone: this.form.name };
        let url = `/third/verifycode/smsCodeApp/v2?${getRulesEncryptStr(
          this.appkeySecret.appkey,
          this.appkeySecret.app_secret
        )}${getParamsEncryptStr(
          newPhone,
          this.appkeySecret.public_key,
          this.appkeySecret.private_key
        )}`;
        let newData = getIdDecryptStr(
          this.form.name,
          this.appkeySecret.public_key,
          this.appkeySecret.private_key
        );
        let phone = getPhoneStr(
          this.form.name,
          this.appkeySecret.public_key,
          this.appkeySecret.private_key
        );
        // http://api.quanmingshuquan.com/api/verifycode/smsCode
        // cofig + `/third/verifycode/smsCodeApp/v2?phone=${this.form.name}`,
        this.$axios
          .post(
            cofig + url,
            {},
            {
              headers: {
                // appkey: this.appkeySecret.appkey,
                FILTERVALIDATED: newData,
                phone: phone,
              },
            }
          )
          // 成功调取接口时
          .then(
            (res) => {
              let openData = JSON.parse(
                getDecryptStr(
                  res.data,
                  this.appkeySecret.public_key,
                  this.appkeySecret.private_key
                )
              );
              // this.form.verification = res.data.resultObj
              // 成功发送弹框
              if (openData.code == "100200") {
                this.$message({
                  message: openData.msg,
                  type: "success",
                });
                this.slideVerify = false;
              }
              // 其他情况弹框
              else {
                this.$message({
                  message: openData.msg,
                  type: "warning",
                });
                this.slideVerify = false;
              }
            },
            // 调取失败时
            (err) => {
              console.log(err);
            }
          );
      }
    },
    onFail() {
      console.log("失败");
    },
    onRefresh() {
      console.log("刷新");
    },
    //点击获取验证码
    getVerifi() {
      //   this.$refs.slideblock.reset();
      if (
        !/^((1[3,4,5,6,7,8,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[1,7]))\d{8}$/.test(
          this.form.name
        )
      ) {
        this.$message({
          message: "请输入正确的手机号",
          type: "warning",
        });
      } else {
        this.slideVerify = true;
      }
    },
    // 点击同意服务条款按钮
    clickAgree() {
      this.agree = !this.agree;
    },
    // 点击服务条款
    agreement() {
      let newPage = this.$router.resolve("/agreement");
      window.open(newPage.href);
    },
    // 点击立即登录
    toLogin() {
      console.log(this.appkeySecret.appkey);
      this.$router.push({ path: this.Jump, query: { appkey: this.appkeySecret.appkey } });
      //   this.$router.push({ name: "download", params: { correct: this.correct } });
    },
    // 点击下一步
    submitForm(formName) {
      if (this.antiShake) {
        this.antiShake = false;
        this.$refs[formName].validate((valid) => {
          // console.log(valid); // valid 是布尔值
          // 验证通过
          if (valid) {
            let newData = getIdDecryptStr(
              this.form.name,
              this.appkeySecret.public_key,
              this.appkeySecret.private_key
            );
            let phone = getPhoneStr(
              this.form.name,
              this.appkeySecret.public_key,
              this.appkeySecret.private_key
            );
            let newDataMon = {
              phone: this.form.name,
              pwd: this.form.password,
              confirmpwd: this.form.passwordAgain,
              verifyCode: this.form.verification,
              invitationCode: this.form.invite,
            };
            let url = "";
            if (this.appkeySecret.appkey === "AL8kco2AzM1uHl5N0g9xaxNMVFp5gB" || this.appkeySecret.appkey === "0CEZsuWzVlmP6kGvt5tu1twFmcThHk") {
              url = `/loginserver/Login/shareRegister?${getRulesEncryptStr(
                this.appkeySecret.appkey,
                this.appkeySecret.app_secret
              )}${getParamsEncryptStr(
                newDataMon,
                this.appkeySecret.public_key,
                this.appkeySecret.private_key
              )}`;
            } else {
              url = `/loginserver/user/register?${getRulesEncryptStr(
                this.appkeySecret.appkey,
                this.appkeySecret.app_secret
              )}${getParamsEncryptStr(
                newDataMon,
                this.appkeySecret.public_key,
                this.appkeySecret.private_key
              )}`;
            }
            this.$axios
              .post(
                cofig + url,
                {
                  newDataMon,
                },
                {
                  headers: {
                    // appkey: this.appkeySecret.appkey,
                    FILTERVALIDATED: newData,
                    phone: phone,
                  },
                }
              )
              .then(
                (res) => {
                  let openData = JSON.parse(
                    getDecryptStr(
                      res.data,
                      this.appkeySecret.public_key,
                      this.appkeySecret.private_key
                    )
                  );
                  console.log(openData);
                  // 成功注册时弹框
                  if (openData.code == "100200") {
                    this.$message({
                      message: "恭喜您，注册成功！",
                      type: "success",
                    });
                    this.$router.push({
                      path: this.Jump,
                      query: { appkey: this.appkeySecret.appkey },
                    });
                    this.antiShake = true;
                  }
                  // 其他情况弹框
                  else {
                    this.$message({
                      message: openData.msg,
                      type: "warning",
                    });
                    this.antiShake = true;
                  }
                },
                // 接口调用失败时
                (err) => {
                    this.antiShake = true;
                  console.log(err);
                }
              );
          }
          // 验证不通过
          else {
            this.$message({
              message: "请输入完整信息!",
              type: "warning",
            });
            this.antiShake = true;
            //   console.log('error submit!!');
            return false;
          }
        });
      }
    },
  },
  // DOM挂载后判断如果没值就聚焦
  mounted() {
    if (this.form.name === "") {
      this.$refs.username.focus();
    }
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.moonFm {
  position: absolute;
  top: 0;
  left: 100%;
  width: 25px;
  height: 25px;
}
h1 {
  font-size: 20px;
  margin-top: 28px;
  margin-left: 24px;
}
.row-input {
  border: 0;
  outline: 0;
  font-size: 12px;
  height: 25px;
  background-color: white;
}
.withMe {
  font-size: 12.5px;
  margin-top: 7px;
  margin-left: 24px;
  font-weight: 500;
  color: #000000;
  opacity: 0.8;
}

.Row {
  margin-top: 28px;
  margin-left: 24px;
  margin-right: 24px;
  border-bottom: 1px solid #e7e7e7;
}

.Row-1 {
  font-weight: bold;
  margin-bottom: 7.5px;
  font-size: 12.5px;
}

::v-deep .el-input__inner {
  height: 16px;
  padding: 0px;
  border: 0px solid;
}

::v-deep .el-form-item__content {
  line-height: normal;
}

.Row-2 {
  margin-bottom: 7.5px;
  font-size: 12.5px;
}

.Row-3 {
  border-left: 1.5px solid rgba(0, 0, 0, 0.4);
  padding-left: 12px;
  margin-top: 24px;
  font-size: 12.5px;
  float: right;
}

.iconStyle {
  color: #2585ff;
  font-size: 14.5px;
  position: absolute;
  top: 15px;
}

.col-1 {
  width: 14.5px;
  height: 14.5px;
  margin-right: 8px;
  position: relative;
}

.get {
  color: #2585ff;
}

.agree {
  margin-top: 16px;
  margin-left: 24px;
  margin-right: 24px;
  font-size: 11.5px;
}

.bigRound {
  display: inline-block;
  width: 11.5px;
  height: 11.5px;
  border: solid 1px black;
  border-radius: 50%;
  position: relative;
  vertical-align: middle;
  margin-bottom: 4px;
  margin-right: 6px;
}

.innerRound {
  display: inline-block;
  background-color: #409eff;
  width: 10.5px;
  height: 10.5px;
  border-radius: 50%;
  position: absolute;
  top: 0.5px;
  left: 0.5px;
}

.agreeClause {
  color: #2585ff;
}

.next {
  margin-left: 24px;
  margin-right: 24px;
  height: 40px;
  line-height: 40px;
}

.nextBtn {
  margin-top: 30px;
  width: 100%;
  height: 40px;
}

.QR {
  margin-top: 20px;
  margin-left: 24px;
  margin-right: 24px;
  text-align: center;
}

.QRcode {
  width: 50px;
  height: 50px;
}
.toLogin {
  float: right;
  color: #9b9b9b;
}
.toLogin span {
  font-size: 14px;
  color: #2585ff;
}

::v-deep .el-form-item__error {
  margin-top: 6px;
}
.row-input /deep/ .el-input__inner {
  background-color: white !important;
  cursor: pointer;
}
.slideVerifyMon {
  position: fixed;
  top: 0;
  background: rgba(128, 128, 128, 0.5);
  width: 100vw;
  height: 100vh;
}
.slideVerify {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -100%);
}
</style>
